import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import serverPostData from "../../utils/ServerPostData";
import classes from "./UserHistory.module.css";
import PHistoryCard from "../HistoryCard/PHistoryCard";
import LoadingPage from "../../pages/LoadingPage/LoadingPage";

export default function UserOHistory(props) {
    const [tg, i18n] = useTranslation("global");
    const [isLoading, setIsLoading] = useState(true);
    const [loadedUsers, setLoadedUsers] = useState([]);
    const formData = new FormData();
  
    useEffect(() => {
      formData.append("email", props.email);
  
      const serverResponse = serverPostData("/fetch-user-p-history", formData);
  
      serverResponse.then((response) => {
        let data = response;
  
        if (data.status === 200) {
          console.log("Data: ", data.data);
          setLoadedUsers(data.data);
          setIsLoading(false); 
        }
        if (data.status === 404) {
          console.log("Data: ", data.data);
          setLoadedUsers(data.data);
          setIsLoading(false); 
        }
      });
    }, [props.email]);
  
    return (
      <div className={classes.box}>
        {isLoading ? (
          < LoadingPage />
        ) : (
          <div>
            <h1>{tg("stats.titles.PHISTORY")}</h1>
            {Object.entries(loadedUsers).length === 0 ? (
              <p>{tg("stats.card.NA_P")}</p>
            ) : (
              Object.entries(loadedUsers).map(([key, value]) => (
                <div key={key} style={{display: "flex", flexDirection: "column", alignItems: "center"}}>
                  <PHistoryCard
                    date={value.date}
                    pointValue={value.pointValue}
                    title={value.prizeName}
                    redeemed={value.redeemed}
                  />
                </div>
              ))
            )}
          </div>
        )}
      </div>
    );
  }
  